'use client';
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import styles from './preview.module.scss';
import { COLORS } from 'utilities';
import { FaBookmark, FaHeart, FaRegBookmark, FaRegHeart } from 'react-icons/fa';
import { IoShareSocialOutline } from 'react-icons/io5';
import { CiCircleAlert } from 'react-icons/ci';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { CategoryHierarchyType, PostType, ThemeEnum, CategoryFieldTypeEnum } from 'types';
import { Button, Spin } from 'antd';
import { RestAPI, TimeDifference } from 'scripts';
import { GalleryComp, MobileHeaderComp, PostContactComp, PostBreadcrumbComp } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import { API, PATH } from 'data';

function PreviewComp({ categories }: { categories?: CategoryHierarchyType[] }) {
    const [isOpen, setOpen] = useState(false);
    const { theme } = useContext(GlobalContext);
    const navigation = useNavigate();
    const { slug } = useParams();
    const [post, setPost] = useState<PostType<'detail'>>();

    useEffect(() => {
        if (slug) RestAPI.get<PostType<'detail'>>(API.posts.myPostDetail(slug)).then((res) => setPost(res.data));
    }, []);

    if (!post)
        return (
            <div className={`w-100 pv-9 center-content h-100`}>
                <Spin />
            </div>
        );

    return (
        <div className={`${styles['detail-layout']}`}>
            <MobileHeaderComp title="پیش نمایش آگهی" onIconClick={() => navigation(PATH.panel.myAds.detail('slug'))} />
            <div className="center-content-y justify-content-between mb-5">
                <div className="t-p2 t-400 t-l-gray1 center-content">
                    <MdOutlineKeyboardArrowRight className="pointer" size={18} color={COLORS.gray1} />
                    <PostBreadcrumbComp category={post.category} categories={categories} />
                </div>
                <div className="center-content g-2">
                    {post.bookmark_id ? (
                        <FaBookmark size={24} color={COLORS.primary} className="pointer" />
                    ) : (
                        <FaRegBookmark
                            size={24}
                            color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3}
                            className="pointer"
                        />
                    )}
                    <IoShareSocialOutline
                        className="pointer"
                        size={24}
                        color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray2}
                    />
                </div>
            </div>
            <div className={`${styles['info-slider-layout']} d-flex`}>
                <div className={`${styles['info']}`}>
                    <div className="d-flex center-content-y justify-content-between mb-3">
                        <h2 className="t-h2 t-500 t-l-black1 t-d-gray3">{post.title}</h2>
                        <div className={`d-flex d-md-none ${styles['box-layout']} center-content-y`}>
                            {/* <div className={`w-100 center-content`}>
                                <PiEyeLight color={COLORS.gray1} size={16} />
                                <p className="t-p1 t-400 t-l-gray1">{post.views_count} بازدید</p>
                            </div> */}
                            <div className={`w-100 center-content pointer`}>
                                {post.like_id ? (
                                    <FaHeart color={COLORS.red} size={16} />
                                ) : (
                                    <FaRegHeart
                                        color={theme === ThemeEnum.light ? COLORS.gray1 : COLORS.gray3}
                                        size={16}
                                    />
                                )}
                                {/* <p className={`t-p1 t-400 t-${post.like_id ? 'red' : 'gray1'}-i`}>
                                    {post.likes_count} لایک
                                </p> */}
                            </div>
                        </div>
                    </div>
                    <div className="center-content g-2 mb-3 d-pre-md-none">
                        {/* <div className={`${styles['see']} ${styles['box']} w-100 center-content`}>
                            <PiEyeLight color={COLORS.gray1} size={16} />
                            <p className="t-p1 t-400 t-l-gray1">{post.views_count} بازدید</p>
                        </div> */}
                        <div
                            className={`${styles['like']} ${post.like_id ? styles['isLike'] : styles['disLike']}  ${styles['box']} w-100 center-content pointer`}
                        >
                            {post.like_id ? (
                                <FaHeart color={COLORS.red} size={16} />
                            ) : (
                                <FaRegHeart color={theme === ThemeEnum.light ? COLORS.gray1 : COLORS.gray3} size={16} />
                            )}
                            {/* <p className={`t-p1 t-400 t-${post.like_id ? 'red' : 'gray1'}-i`}>
                                {post.likes_count} لایک
                            </p> */}
                        </div>
                    </div>
                    <div className={`${styles['info-text']} mb-4`}>
                        <div className="center-content justify-content-between pb-2 mb-2">
                            <p className="t-p1 t-400 t-l-gray1 t-d-gray2">موقعیت مکانی</p>
                            <p className="t-p1 t-400 t-l-black1 t-d-gray3">
                                {post.locations?.map((i) => i.title).join(', ')}
                            </p>
                        </div>
                        <div className="center-content justify-content-between pb-2 mb-2">
                            <p className="t-p1 t-400 t-l-gray1 t-d-gray2">زمان</p>
                            <p className="t-p1 t-400 t-l-black1 t-d-gray3">{TimeDifference(post.created_at)}</p>
                        </div>
                        {post.category_fields_values
                            ?.sort((a, b) => (b.category_field.order ?? 0) - (a.category_field.order ?? 0))
                            .map((item, index) => (
                                <div key={index} className="center-content justify-content-between pb-2">
                                    <p className="t-p1 t-400 t-l-gray1 t-d-gray2">{item.category_field.title}</p>
                                    <p className="t-p1 t-400 t-l-black1 t-d-gray3">
                                        {item.option
                                            ? item.option.title
                                            : item.category_field.type === CategoryFieldTypeEnum.number
                                              ? item.value_number
                                              : item.value}{' '}
                                        {item.category_field.unit ?? ''}
                                    </p>
                                </div>
                            ))}
                    </div>
                    <div className={`${styles['desc']} mb-4`}>
                        <h3 className="t-h3 t-l-black1 t-d-gray3 t-500 mb-2">توضیحات</h3>
                        <p className="t-p2 t-l-black1 t-d-gray2 t-400">{post.description}</p>
                    </div>
                    <div className={`${styles['spam']} justify-content-between center-content-y pointer`}>
                        <div className="center-content-y">
                            <CiCircleAlert size={20} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray2} />
                            <p className="t-p2 t-400 t-l-black1 t-d-gray2">گزارش تخلف آگهی</p>
                        </div>
                        <MdOutlineKeyboardArrowLeft
                            size={16}
                            color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray2}
                        />
                    </div>
                    <div className={`${styles['contacts-btns']} center-content g-2 d-md-none mt-3`}>
                        <Button onClick={() => setOpen(true)} className={`w-100 ${post.has_phone ? '' : 'd-none-i'}`}>
                            اطلاعات تماس
                        </Button>
                        <Button className="w-100">چت</Button>
                    </div>
                </div>
                <div className={`${styles['slider']}`}>
                    <GalleryComp
                        gallery={post.gallery?.length ? post.gallery : post.main_image ? [post.main_image] : undefined}
                        className={styles['gallery']}
                    />
                    <div className="center-content g-2 d-pre-md-none mt-3">
                        <Button onClick={() => setOpen(true)} className={`w-100 ${post.has_phone ? '' : 'd-none-i'}`}>
                            اطلاعات تماس
                        </Button>
                        <Button className="w-100">چت</Button>
                    </div>
                </div>
            </div>
            <PostContactComp open={isOpen} onClose={() => setOpen(false)} post={post} />
        </div>
    );
}

export default PreviewComp;
